module.exports = __webpack_public_path__ + "img/main4.672d7ec7.png";